<template>
  <v-snackbar
    v-model="visible"
    :timeout="-1"
    location="bottom"
    multi-line
    class="cookie-consent-banner"
    elevation="4"
    role="region"
    :aria-label="t('cookieBanner.aria')"
  >
    <div class="cookie-consent-banner__content">
      <p class="cookie-consent-banner__text">
        {{ t('cookieBanner.text') }}
        <RouterLink :to="{ name: 'cookie-policy' }" class="cookie-consent-banner__link">
          {{ t('cookieBanner.policy_link') }}
        </RouterLink>
      </p>
      <div class="cookie-consent-banner__actions">
        <v-btn
          variant="text"
          size="small"
          class="mr-2"
          @click="reject"
        >
          {{ t('cookieBanner.reject') }}
        </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          size="small"
          @click="accept"
        >
          {{ t('cookieBanner.accept') }}
        </v-btn>
      </div>
    </div>
  </v-snackbar>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { RouterLink } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { COOKIE_CONSENT_KEY, loadAnalytics } from '@/plugins/analytics'

const { t } = useI18n()
const visible = ref(false)

function accept() {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted')
  }
  loadAnalytics()
  visible.value = false
}

function reject() {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'rejected')
  }
  visible.value = false
}

onMounted(() => {
  if (typeof localStorage === 'undefined') return
  const consent = localStorage.getItem(COOKIE_CONSENT_KEY)
  if (consent !== 'accepted' && consent !== 'rejected') {
    visible.value = true
  }
})
</script>

<style scoped>
.cookie-consent-banner__content {
  width: 100%;
}
.cookie-consent-banner__text {
  margin: 0 0 12px 0;
  font-size: 0.9rem;
  line-height: 1.4;
}
.cookie-consent-banner__link {
  color: rgb(var(--v-theme-primary));
  text-decoration: underline;
}
.cookie-consent-banner__link:hover {
  opacity: 0.9;
}
.cookie-consent-banner__actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}
:deep(.v-snackbar__wrapper) {
  max-width: 100%;
}
</style>
